import React, { useEffect } from 'react';

const AdSenseAds = () => {

    useEffect(() => {
        // Load Google AdSense script asynchronously
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, []);

    return (
        <div>
            <ins className="adsbygoogle"
                style={{ display: "block" }}
                data-ad-client="ca-pub-3815487360279960"
                data-ad-slot="9674608872"
                data-ad-format="auto"
                data-full-width-responsive="true">
            </ins>
        </div>
    )
}

export default AdSenseAds;